import React from 'react'
import {Steps} from 'antd'

const CheckoutSteps = ({t, current}) => (
  <div className='checkoutSteps'>
    <div>
      <Steps current={current - 1} progressDot>
        <Steps.Step title={t('1. step')} description={t('summary')}/>
        <Steps.Step title={t('2. step')} description={t('delivery & billing information')}/>
        <Steps.Step title={t('3. step')} description={t('payment')}/>
      </Steps>
    </div>
  </div>
)

export default CheckoutSteps
